import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faLinkedinIn, faInstagram } from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
  return (
    <>
      <footer>
        <div className="container-fluid footerSection">
          <div className="row">
            {/* Left Section */}
            <div className="col-md-5 footerLeft">
              <div className="footerP px-4">
                <div>
                  <img src={'assets/img/footer/footerlogo.png'} className="logo" alt="ClubNet Logo" />
                </div>
                <p className="mt-15 textWhite py-4">
                  ClubNet offers consulting services to help businesses identify
                  their IT needs and develop strategies for implementing
                  technology solutions that align with their goals and budget.
                </p>
              </div>
            </div>

            {/* Right Section */}
            <div className="col-md-7 footerP px-4">
              <div className="row mb-3">
                <div className="col-md-3">
                  <h2>Useful Links</h2>
                  <ul className="footerLinks">
                    <li>
                      <a
                        href="https://clubnet.app/club/index.html"
                        className="link-hover"
                      >
                        Home
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://clubnet.app/club/networkmembershipmanagement.html"
                        className="link-hover"
                      >
                        Features
                      </a>
                    </li>
                    <li>
                      <a href="#" className="link-hover">
                        Solutions
                      </a>
                    </li>
                    <li>
                      <a href="#" className="link-hover">
                        Pricing
                      </a>
                    </li>
                    <li>
                      <a href="#" className="link-hover">
                        Partners
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="col-md-9">
                  <h2>Company Information</h2>
                  <div className="iconbox-inner">
                    <div className="box-icon">
                      <div className="icons location">
                        <FontAwesomeIcon icon={faLocationDot} />
                      </div>
                      <div className="content">
                        <span className="text-2">
                          Palasia office, 405, The Mark, 20-A, Anand Bazaar
                          Square, Old Palasia, Indore, Madhya Pradesh 452001
                        </span>
                      </div>
                    </div>

                    <div className="box-icon">
                      <div className="icons phoneIcon">
                        <FontAwesomeIcon icon={faPhone} />
                      </div>
                      <div className="content">
                        <span className="text-2">+91 99930 53695</span>
                      </div>
                    </div>

                    <div className="box-icon mt-15">
                      <div className="icons envelopeIcon">
                        <FontAwesomeIcon icon={faEnvelope} />
                      </div>
                      <div className="content">
                        <span className="text-2">
                          <a
                            href="mailto:info@clubnet.in"
                            className="foonerLink"
                          >
                            info@clubnet.in
                          </a>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="topBorder">
                <div className="row pt-4">
                  <div className="col-md-6">
                    <ul className="pb-3 d-flex align-items-start justify-content-start gap-3 socialIcon footerSocialIcon">
                      <li>
                        <a href="https://www.facebook.com/people/Club-Net/pfbid02BJ3wuFgWnUSP1YPUd7Srhi3rTcyb3fLYeC4infuhHrSiNUkvvzoWdTWgKaXVVtc2l/">
                          <FontAwesomeIcon icon={faFacebookF} />
                        </a>
                      </li>
                      <li>
                        <a href="https://www.linkedin.com/in/clubnet-b8b647318/">
                          <FontAwesomeIcon icon={faLinkedinIn} />
                        </a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com/clubn_et/">
                          <FontAwesomeIcon icon={faInstagram} />
                        </a>
                      </li>
                    </ul>
                  </div>

                  <div className="col-md-6">
                    <div className="copyRight d-flex align-items-start justify-content-end textWhite me-5">
                    Copyright© 2025:TechSimba Pvt Ltd | All rights reserved
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
